import type { PartDefinition } from "@rogue/rackbuilder"
import { S4 } from "../../modelPaths"
import { SquatStandOptions } from "../../RackTypes"
import { BarBuilder } from "../bar/barBuilder"

export type S4StandOptions = Pick<SquatStandOptions, 'bench' | 'bar'>

export class S4Builder {
  constructor(private options: S4StandOptions) {}

  public build(): PartDefinition {
    const leftJcup: PartDefinition = { mesh: `${S4}#jcup`, slots: {} }
    const rightJcup: PartDefinition = { mesh        : `${S4}#jcup`,
      slots       : {},
      adjustments : [{ axis: 'Y', type: 'rotate', amount: 180, pieces: ['clasp'] }],
    }

    const jcupSlot = this.options.bench ? 'jcup-low' : 'jcup-high'

    const rightSide: PartDefinition = {
      mesh  : `${S4}#s4`,
      slots : {
        [jcupSlot]: rightJcup,
      },
    }

    const leftSide: PartDefinition = {
      mesh  : `${S4}#s4`,
      slots : {
        [jcupSlot] : leftJcup,
        otherside  : rightSide,
      },
    }

    if (this.options.bench) {
      leftSide.slots.bench = this.options.bench
    }

    if (this.options.bar) {
      leftJcup.slots.bar = new BarBuilder(this.options.bar).build()
    }

    return leftSide
  }
}
